
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcard",
      function () {
        return require("private-next-pages/giftcard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftcard"])
      });
    }
  